// Constants
export const LANGUAGE_SELECTED = '[LANGUAGE] Selected';

// Actions
export const switchLanguage = language => ({
  type: LANGUAGE_SELECTED,
  language,
});
